import React from 'react';
import Icon from './icons';
import { GENDOCS, getVers } from './gendocs';
import { openS3, saveS3ToProject } from './docgen';
import type { Project } from './types';

interface Props {
  p: Project;
  onPv: (k: string, idx?: number) => void;
  onVer: (k: string) => void;
  toast: (m: string) => void;
}

export default function DocsTab({ p, onPv, onVer, toast }: Props) {
  const keys = Object.keys(GENDOCS);
  const isMade = (k: string): boolean => {
    const v = getVers(p, k);
    const last = v[v.length - 1];
    return !!(last && (last.s3doc || last.s3pdf));
  };
  const genN = keys.filter(isMade).length;
  return (
    <div className="panel">
      <div className="panel-h"><b>생성 문서 ({keys.length}종)</b><span className="hs">{genN}/{keys.length} 생성됨 · 3·7단계에서 자동 생성</span></div>
      <div className="panel-b">
        {keys.map((k) => {
          const vers = getVers(p, k);
          const last = vers[vers.length - 1];
          const made = !!(last && (last.s3doc || last.s3pdf));
          return (
            <div className="s3file" key={k} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <span className="rf" style={{ flex: 1, minWidth: 0 }}>📄 {GENDOCS[k].title}{GENDOCS[k].seal ? <span className="pill p-blue" style={{ marginLeft: 6 }}>날인</span> : null}</span>
              {made ? (
                <>
                  <span className="pill p-green">생성됨{vers.length > 1 ? ' · v' + vers.length : ''}</span>
                  {last.s3pdf ? <button className="rbtn" onClick={() => onPv(k)}>👁</button> : null}
                  <button className="rbtn" onClick={() => {
                    const key = last.s3doc || last.s3pdf;
                    const nm = last.s3doc ? last.doc : (last.pdf || last.doc);
                    if (key) void saveS3ToProject(p, key, nm, toast);
                  }}>⬇</button>
                  {vers.length > 1 ? <button className="rbtn" onClick={() => onVer(k)}>🕘</button> : null}
                </>
              ) : (
                <span className="pill p-gray">대기</span>
              )}
            </div>
          );
        })}
        <div className="alert blue" style={{ marginTop: 10 }}><Icon n="info" /><div><b>문서는 단계 진행에서 생성됩니다</b><span>3단계(규약·결성계획서)·7단계 등에서 마스터값으로 자동 생성되며, 여기서 생성된 문서를 한눈에 모아 볼 수 있습니다.</span></div></div>
      </div>
    </div>
  );
}
